import { useEffect } from 'react'
import { NextPage } from 'next'
import { useRouter } from 'next/router'
import { useTranslation } from 'react-i18next'

import PopupModalTemplate from '@/components/PopupModalTemplate'
import { useCookies } from '@/libs/helpers/hooks/useCookies'
import { useConfiguration } from '@/providers/configuration/ConfigurationContext'
import { useModal } from '@/providers/modal'
import { LoadScreen, SvgIcon } from '@/tbui'

const PasswordResetPage: NextPage = () => {
  const { userSession } = useConfiguration()
  const { openModal, closeModal } = useModal()
  const { t } = useTranslation()
  const router = useRouter()
  const { getRedirectURLCookie, removeRedirectURLCookie } = useCookies()

  useEffect(() => {
    if (userSession.isInitialized) {
      const redirectURL = { url: '/', as: '/', ...getRedirectURLCookie() }

      // open modal with user prompt to re-login
      openModal(
        <PopupModalTemplate
          name="change-password"
          icon={<SvgIcon fontSize="50px" name="check_circle" color="SUCCESS" />}
          title={t('tbdine.password_change.title')}
          message={t('tbdine.password_change.description')}
          callToAction={t('tbdine.password_change.cta')}
          onClose={async () => {
            removeRedirectURLCookie()
            await router.push(redirectURL.url, redirectURL.as)
            closeModal()
          }}
        />,
        {
          variant: 'SMALL',
          forceSubmit: true,
        }
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userSession.isInitialized])

  return <LoadScreen />
}

export default PasswordResetPage
